// extracted by mini-css-extract-plugin
export var container = "_62-0";
export var icon = "_62-1";
export var text = "_62-2";